'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hideGiftCardIntl = function hideGiftCardIntl() {
  if (window.Flow && window.Flow.cart && window.Flow.getExperience()) {
    if ($('.template__search').length > 0) {
      if ($('[data-product-handle="gift-card"]').length == 1) {
        if ($('.product-grid-item').length == 1) {
          $('.pagination,.product-grid').hide();
          $('.no-results-international').show();
          $('.collection-product-container').addClass('no-results');
        }
        $('[data-product-handle="gift-card"]').remove();
      }
    }
  }
};

var localizeWithFlow = function localizeWithFlow(findify) {
  // Have to listen for widgetAttach after findify ready
  findify.listen(function (event, widget) {
    if (widget.type === 'search' || widget.type === 'autocomplete') {
      // only want on single search widget
      var checkForFlow = setInterval(function () {
        // Flow is async, so keep checking
        if (window.Flow.getExperience) {
          // Flow WILL load
          clearInterval(checkForFlow);
          var findifyContainer = document.getElementById('findify_results');

          if (window.Flow.getExperience()) {
            // only on international
            widget.agent.on('change:items', function (items) {
              // wait for items to be loaded into search widget
              var handles = items.toJSON().map(function (item) {
                return item.toJSON().selected_variant_id;
              });

              window.Flow.variants.load({ // get flow items via handles
                variants: handles,
                success: function success(code, response) {
                  Object.values(response).forEach(function (item) {
                    if (item.status === 'excluded' || item.status === 'restricted') {
                      document.querySelector('a[href="/products/' + item.handle + '"]').parentElement().style.display = 'none';
                    }
                    document.querySelector('a[href="/products/' + item.handle + '"] .findify-components--cards--product--price__price').innerText = item.prices.item.label;
                    if (item.prices.compare_at) {
                      document.querySelector('a[href="/products/' + item.handle + '"] .findify-components--cards--product--price__compare').innerText = item.prices.compare_at.label;
                    }
                  });
                  if (findifyContainer != null) findifyContainer.classList.add('price-loaded');
                }
              });
            });
          } else if (findifyContainer != null) {
            // local, so just show prices
            findifyContainer.classList.add('price-loaded');
          }
        }
      }, 100);
    }
  });
};

var bindUIActions = function bindUIActions() {
  var sortVal = 'manual';

  window.Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        window.Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue);
        sortVal = typeof window.Shopify.queryParams.view !== 'undefined' ? window.Shopify.queryParams.view : 'manual';
      }
    }
  }

  $('.js-sort-by').val(sortVal).bind('change', function (_ref) {
    var self = _ref.currentTarget;

    window.Shopify.queryParams.view = $(self).val();
    location.search = jQuery.param(window.Shopify.queryParams).replace(/\+/g, '%20');
  });
};

var init = exports.init = function init() {
  bindUIActions();

  window.Flow.set('on', 'ready', function () {
    hideGiftCardIntl();
  });

  // Fires on Findify Ready (but before widgets attached)
  // window.findifyCallbacks = [ localizeWithFlow ];
};

exports.default = {
  init: init
};